<template>
  <loading :active="isLoading" :can-cancel="false" :is-full-page="true" :z-index="99999"></loading>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading,
  },
  computed: {
    ...mapState('loading', ['isLoading']),
  },
};
</script>
